<ng-container [formGroup]="formGroup">
    <!-- choix du champs de formulaire -->
    <ng-template [ngSwitch]="type" let-name #fieldTemplate>

        <ng-container *ngIf="isOperandMandatory(value, name)">

            <kal-input
                type="number"
                [name]="name"
                [formControlName]="name"
                [value]="value[name]"
                *ngSwitchCase="'number'"
                [updateOnEvent]="'blur'"></kal-input>
            <kal-datepicker
                [name]="name"
                [formControlName]="name"
                [value]="value[name]"
                *ngSwitchCase="'date'"></kal-datepicker>

        </ng-container>

    </ng-template>

    <!-- sélection de l'opérateur -->
    <div class="flexLine">

        <kal-select [value]="value.comparator"
                    formControlName="comparator">
            <kal-option [value]="null">Non défini</kal-option>
            <kal-option
                *ngFor="let operator of comparatorsList"
                [label]="operator">
                {{ operator }}
            </kal-option>
        </kal-select>

        <!-- sélection du min -->
        <ng-container *ngTemplateOutlet="fieldTemplate; context: {$implicit: 'min'}"></ng-container>

        <!-- sélection du max -->
        <ng-container *ngTemplateOutlet="fieldTemplate; context: {$implicit: 'max'}"></ng-container>

    </div>

</ng-container>
